import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { Loader } from "components/Loader";
import { tableRowSx } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";
const overTimeKeyPair = [
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    name: "Approval Type",
    key: "approval_type",
  },
  {
    key: "check_in_datetime",
    name: "Check-in",
  },
  {
    key: "check_out_datetime",
    name: "Check-out",
  },
  {
    key: "approvedby",
    name: "Approver",
  },
  {
    key: "approvedat",
    name: "Approved At",
  },
];

export const History = ({ startDate, endDate }) => {
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const { departmentId } = useSelector((state) => state.userReducer);
  const [overTimeDetails, setOverTimeDetails] = useState([1]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [listViewPage, setListViewPage] = useState(0);
  const [loader, setLoader] = useState(true);
  const [historyData, setHistoryData] = useState([]);
  const containerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  useEffect(() => {
    const fetchHistory = async () => {
      setLoader(true);
      try {
        const response = await fetch(
          `${domain}week-off-approvals/?user_id=${userDetails.id}&start_date=${startDate}&end_date=${endDate}&status=Approved&department_id=${departmentId}&company_id=${topbarCompanyId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const combinedData = res.map((item) => ({
            ...item,
            overtime_period: `${item.check_in_datetime || "N/A"} to ${
              item.check_out_datetime || "N/A"
            }`,
          }));
          setOverTimeDetails(combinedData);
          setHistoryData(combinedData);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
      setLoader(false);
    };
    fetchHistory();
  }, [
    departmentId,
    domain,
    endDate,
    startDate,
    token,
    topbarCompanyId,
    userDetails.id,
  ]);

  useEffect(() => {
    const searchFields = [
      "user_name",
      "date",
      "shift",
      "check_in_datetime",
      "check_out_datetime",
      "approvedby",
      "createdat",
    ];
    const filteredResults = historyData.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setOverTimeDetails(filteredResults);
    setListViewPage(0);
  }, [historyData, globalSearchValue]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [listViewPage]);

  return (
    <React.Fragment>
      {loader ? (
        <Loader />
      ) : (
        <Mui.Grid container>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ mt: 2, width: "100%", paddingRight: 1, ml: 2, mr: 2 }}
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  {overTimeKeyPair.map((header) => (
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      {header.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {overTimeDetails.length === 0 ? (
                  <InfoMessage dataLength={historyData} />
                ) : (
                  overTimeDetails
                    ?.slice(
                      listViewPage * rowsPerPage,
                      listViewPage * rowsPerPage + rowsPerPage
                    )
                    .map((department) => (
                      <Mui.TableRow sx={tableRowSx}>
                        {overTimeKeyPair.map((header) => (
                          <Mui.TableCell sx={{ color: themes.headLine }}>
                            {header.name === "Employee name" ? (
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={department?.user_name
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={department?.image_url ?? optionalAvathar}
                                />
                                <Mui.Typography
                                  sx={{
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    paddingLeft: 1,
                                  }}
                                >
                                  {department?.user_name
                                    ? department?.user_name
                                    : "N/A"}
                                </Mui.Typography>
                              </Mui.Stack>
                            ) : department[header.key] ? (
                              department[header.key]
                            ) : (
                              "N/A"
                            )}
                          </Mui.TableCell>
                        ))}
                      </Mui.TableRow>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
            {overTimeDetails?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={overTimeDetails?.length}
                rowsPerPage={rowsPerPage}
                page={listViewPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Mui.TableContainer>
        </Mui.Grid>
      )}
    </React.Fragment>
  );
};
